module.exports = __webpack_public_path__ + "static/media/bus.774d158a.svg";